'use strict';

module.exports = {
    FINISHED_APPLYING_NOTIFICATIONS_TO_SCENARIO: 'finished_applying_notifications_to_scenario',
    FINISHED_APPLYING_NOTIFICATIONS_TO_PROMOTION: 'finished_applying_notifications_to_promotion',
};
